import { call, put, takeEvery } from "redux-saga/effects"

import {
    ADD_NEW_MERCHANT_GROUP,
    GET_MERCHANT_GROUP,
    GET_MERCHANT_GROUP_DETAIL,
    UPLOAD_BASE64_FILE,
    GET_MERCHANT_GROUP_COMMUNICATIONS,
    MANAGE_MERCHANT_GROUP_COMMUNICATION,
    GET_MERCHANT_GROUP_CONTACTS,
    MANAGE_MERCHANT_GROUP_CONTACT,
    GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS,
    MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION,
    GET_MERCHANT_GROUP_BANKING,
    GET_MERCHANT_GROUP_BANKING_DETAIL,
    ADD_NEW_MERCHANT_GROUP_BANKING,
    MANAGE_MERCHANT_GROUP_BANKING,
    TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT,
    CHECK_MERCHANT_GROUP_BANKING_STATUS,
    DELETE_MERCHANT_GROUP,
    GET_MERCHANT_GROUP_ADMIN_USER,
    CREATE_MERCHANT_GROUP_ADMIN_USER,
} from "./actionTypes"

import {
    getMerchantGroupSuccess,
    getMerchantGroupFail,
    addNewMerchantGroupSuccess,
    addNewMerchantGroupFail,
    getMerchantGroupDetailSuccess,
    getMerchantGroupDetailFail,
    uploadBase64FileFail,
    uploadBase64FileSuccess,
    getMerchantGroupCommunicationsSuccess,
    getMerchantGroupCommunicationsFail,
    manageMerchantGroupCommunicationSuccess,
    manageMerchantGroupCommunicationFail,
    getMerchantGroupContactsSuccess,
    getMerchantGroupContactsFail,
    manageMerchantGroupContactSuccess,
    manageMerchantGroupContactFail,
    getMerchantGroupContacts as getMerchantGroupContactsAction,
    getMerchantGroupContactCommunicationsSuccess,
    getMerchantGroupContactCommunicationsFail,
    manageMerchantGroupContactCommunicationSuccess,
    manageMerchantGroupContactCommunicationFail,
    getMerchantGroupContactCommunications as getMerchantGroupContactCommunicationsAction,
    getMerchantGroupBankingSuccess,
    getMerchantGroupBankingFail,
    getMerchantGroupBankingDetail as getMerchantGroupBankingDetailAction,
    getMerchantGroupBankingDetailSuccess,
    getMerchantGroupBankingDetailFail,
    addNewMerchantGroupBankingSuccess,
    addNewMerchantGroupBankingFail,
    manageMerchantGroupBankingSuccess,
    manageMerchantGroupBankingFail,
    toggleMerchantGroupBankingDefaultSuccess,
    toggleMerchantGroupBankingDefaultFail,
    checkMerchantGroupBankingStatusSuccess,
    checkMerchantGroupBankingStatusFail,
    deleteMerchantGroupSuccess,
    deleteMerchantGroupFail,
    getMerchantGroupAdminUserSuccess,
    getMerchantGroupAdminUserFail,
    createMerchantGroupAdminUserSuccess,
    createMerchantGroupAdminUserFail,
} from "./actions"

import {
    getMerchantGroup,
    manageMerchantGroup,
    uploadBase64File,
    getMerchantGroupCommunications,
    manageMerchantGroupCommunication,
    getMerchantGroupContacts,
    manageMerchantGroupContact,
    getMerchantGroupContactCommunications,
    manageMerchantGroupContactCommunication,
    getMerchantGroupBanking,
    getMerchantGroupBankingDetail,
    addNewMerchantGroupBanking,
    manageMerchantGroupBanking,
    toggleMerchantGroupBankingStatus,
    toggleMerchantGroupBankingDefault,
    checkMerchantGroupBankingStatus as checkMerchantGroupBankingStatusAPI,
    getMerchantGroupAdminUser,
    createMerchantGroupAdminUser,
} from "../../helpers/backend_helper"

function* fetchMerchantGroup({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantGroup, options)
        yield put(getMerchantGroupSuccess(response))
    } catch (error) {
        yield put(getMerchantGroupFail(error))
    }
}

function* onAddMerchantGroup({ payload: { data, options, history } }) {
    try {
        const response = yield call(manageMerchantGroup, data, options)
        yield put(addNewMerchantGroupSuccess(response))
        const { merchantGroupID } = response
    } catch (error) {
        yield put(addNewMerchantGroupFail(error))
    }
}


// uploadBase64File
function* uploadBase64FileSaga({ payload }) {
    try {
        const response = yield call(uploadBase64File, payload)
        yield put(uploadBase64FileSuccess(response))
    } catch (error) {
        yield put(uploadBase64FileFail(error))
    }
}

function* fetchMerchantGroupDetail({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantGroup, options)
        yield put(getMerchantGroupDetailSuccess(response))
    } catch (error) {
        yield put(getMerchantGroupDetailFail(error))
    }
}

function* fetchMerchantGroupCommunications({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantGroupCommunications, options)
        yield put(getMerchantGroupCommunicationsSuccess(response))
    } catch (error) {
        if (error.message === "No content available") {
            yield put(getMerchantGroupCommunicationsSuccess([]))
        } else {
            yield put(getMerchantGroupCommunicationsFail(error))
        }
    }
}

function* onManageMerchantGroupCommunication({
    payload: { data, options, history },
}) {
  try {
    const response = yield call(manageMerchantGroupCommunication, data, options)
    yield put(manageMerchantGroupCommunicationSuccess(response))

    try {
      const commResponse = yield call(getMerchantGroupCommunications, {
        headers: {
          "input-parameters": { merchantGroupID: response.merchantGroupID },
        },
      })
      yield put(getMerchantGroupCommunicationsSuccess(commResponse))
    } catch (refreshError) {
      if (refreshError.message === "No content available") {
        yield put(getMerchantGroupCommunicationsSuccess([]))
      } else {
        yield put(getMerchantGroupCommunicationsFail(refreshError))
      }
    }
  } catch (error) {
    yield put(manageMerchantGroupCommunicationFail(error))
  }
}


// Merchant Group Contacts Saga
function* fetchMerchantGroupContacts({ payload: { options, history } }) {
  try {
    const response = yield call(getMerchantGroupContacts, options)
    yield put(getMerchantGroupContactsSuccess(response))
  } catch (error) {
    if (error.message === "No content available") {
      yield put(getMerchantGroupContactsSuccess([]))
    } else {
      yield put(getMerchantGroupContactsFail(error))
    }
  }
}

// Manage Merchant Group Contact Saga
function* onManageMerchantGroupContact({
    payload: { data, options, history },
}) {
    try {
        // If there's a photo to upload, handle it first
        let finalData = { ...data }

        if (data.photo && data.photo.base64encodedFileByteArray) {
            try {
                const uploadResponse = yield call(uploadBase64File, data.photo, options)
                if (uploadResponse && uploadResponse.fileName) {
                    finalData.photo = uploadResponse.fileName
                } else {
                    throw new Error("Failed to upload photo")
                }
            } catch (uploadError) {
                yield put(
                    manageMerchantGroupContactFail({
                        message: "Failed to upload photo. Please try again.",
                    })
                )
                return
            }
        } else if (!data.photo || data.photo === "") {
            finalData.photo = ""
        }

        // Remove communications from finalData for contact creation
        const { communications, ...contactData } = finalData

        const response = yield call(
            manageMerchantGroupContact,
            contactData,
            options
        )
        yield put(manageMerchantGroupContactSuccess(response))

        // If contact was created successfully and has communications, create them
        if (
            response &&
            response.merchantGroupContactID &&
            communications &&
            communications.length > 0 &&
            data.actionType === "create"
        ) {
            for (const comm of communications) {
                if (
                    comm.channelValue &&
                    comm.channelValue.trim() !== "" &&
                    comm.commChannelID
                ) {
                    try {
                        const commPayload = {
                            mgContactID: response.merchantGroupContactID,
                            commChannelID: parseInt(comm.commChannelID),
                            channelValue: comm.channelValue,
                            actionType: "create",
                        }
                        yield call(
                            manageMerchantGroupContactCommunication,
                            commPayload,
                            options
                        )
                    } catch (commError) {
                        console.warn("Failed to create communication:", commError)
                        // Continue with other communications even if one fails
                    }
                }
            }
        }

        // Refresh the contacts list
        if (data.merchantGroupID) {
            yield put(
                getMerchantGroupContactsAction(
                    {
                        headers: {
                            "input-parameters": { merchantGroupID: data.merchantGroupID },
                        },
                    },
                    history
                )
            )
        }
    } catch (error) {
        yield put(manageMerchantGroupContactFail(error))
    }
}

// Merchant Group Contact Communications Saga
function* fetchMerchantGroupContactCommunications({
    payload: { options, history },
}) {
  try {
    const response = yield call(getMerchantGroupContactCommunications, options)
    yield put(getMerchantGroupContactCommunicationsSuccess(response))
  } catch (error) {
    if (error.message === "No content available") {
      yield put(getMerchantGroupContactCommunicationsSuccess([]))
    } else {
      yield put(getMerchantGroupContactCommunicationsFail(error))
    }
  }
}

// Manage Merchant Group Contact Communication Saga
function* onManageMerchantGroupContactCommunication({
    payload: { data, options, history },
}) {
    try {
        const response = yield call(
            manageMerchantGroupContactCommunication,
            data,
            options
        )
        yield put(manageMerchantGroupContactCommunicationSuccess(response))

        // Refresh the contact communications list
        if (data.mgContactID) {
            yield put(
                getMerchantGroupContactCommunicationsAction(
                    {
                        headers: {
                            "input-parameters": { mgContactID: data.mgContactID },
                        },
                    },
                    history
                )
            )
        }
    } catch (error) {
        yield put(manageMerchantGroupContactCommunicationFail(error))
    }
}

// Merchant Group Banking Saga
function* fetchMerchantGroupBanking({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantGroupBanking, options)
        yield put(getMerchantGroupBankingSuccess(response))
    } catch (error) {
        yield put(getMerchantGroupBankingFail(error))
    }
}

// Manage Merchant Group Banking Saga
function* onManageMerchantGroupBanking({
    payload: { data, options, history },
}) {
    try {
        let response
        
        // Check if this is a toggle operation (activate/deactivate)
        if (data.actionType === "activate" || data.actionType === "deactivate") {
            // Use new toggle API with simplified payload
            const togglePayload = {
                actionType: data.actionType,
                merchantGroupBankingID: data.merchantGroupBankingID
            }
            response = yield call(toggleMerchantGroupBankingStatus, togglePayload, options)
        } else {
            // Use existing manage API for other operations
            response = yield call(manageMerchantGroupBanking, data, options)
        }
        
        yield put(manageMerchantGroupBankingSuccess(response))
        // Refresh banking list after successful operation (activate/deactivate)
        if (response.merchantGroupID || data.merchantGroupID) {
            // yield delay(1000)
            yield put(
                getMerchantGroupBankingDetailAction({
                    headers: {
                        "input-parameters": { merchantGroupID: response.merchantGroupID || data.merchantGroupID },
                    }
                })
            )
        }
    } catch (error) {
        yield put(manageMerchantGroupBankingFail(error))
    }
}

// Toggle Merchant Group Banking Default Saga
function* toggleMerchantGroupBankingDefaultSaga({ payload: { data, options, history } }) {
    try {
        const response = yield call(toggleMerchantGroupBankingDefault, data, options)
        yield put(toggleMerchantGroupBankingDefaultSuccess(response))

        // Refresh banking list after successful operation
        if (response.merchantGroupID || data.merchantGroupID) {
            yield put(
                getMerchantGroupBankingDetailAction({
                    headers: {
                        "input-parameters": { merchantGroupID: response.merchantGroupID || data.merchantGroupID },
                    }
                })
            )
        }
    } catch (error) {
        yield put(toggleMerchantGroupBankingDefaultFail(error))
    }
}

// Check Merchant Group Banking Status Saga
function* checkMerchantGroupBankingStatusSaga({ payload: { destinationID } }) {
    try {
        const response = yield call(checkMerchantGroupBankingStatusAPI, destinationID, {})
        yield put(checkMerchantGroupBankingStatusSuccess(response.destinationID, response.status))
    } catch (error) {
        yield put(checkMerchantGroupBankingStatusFail(error))
    }
}

// Merchant Group Banking Detail (List) Saga
function* fetchMerchantGroupBankingDetail({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantGroupBankingDetail, options)
        yield put(getMerchantGroupBankingDetailSuccess(response))
    } catch (error) {
        yield put(getMerchantGroupBankingDetailFail(error))
    }
}

// Add New Merchant Group Banking Saga
function* onAddNewMerchantGroupBanking({
    payload: { data, options, history },
}) {
    try {
        const response = yield call(addNewMerchantGroupBanking, data, options)
        yield put(addNewMerchantGroupBankingSuccess(response))

        // Refresh banking list after successful creation
        if (data.merchantGroupID) {
            yield put(
                getMerchantGroupBankingDetailAction({
                    headers: {
                        "input-parameters": { merchantGroupID: data.merchantGroupID },
                    },
                })
            )
        }
    } catch (error) {
        yield put(addNewMerchantGroupBankingFail(error))
    }
}

// Delete Merchant Group Saga
function* onDeleteMerchantGroup({ payload: { data, options, history } }) {
    try {
        const response = yield call(manageMerchantGroup, data, options)
        yield put(deleteMerchantGroupSuccess(response))

        // Refresh the merchant groups list using pagination from options
        const refreshPagination = options?.refreshPagination || {}
        try {
            const refreshResponse = yield call(getMerchantGroup, {
                headers: {
                    "input-parameters": { keyword: refreshPagination.keyword || "" },
                },
                pagination: { startIndex: refreshPagination.startIndex ?? 0 },
            })
            yield put(getMerchantGroupSuccess(refreshResponse))
        } catch (refreshError) {
            if (refreshError.message === "No content available") {
                yield put(getMerchantGroupSuccess([]))
            } else {
                yield put(getMerchantGroupFail(refreshError))
            }
        }
    } catch (error) {
        yield put(deleteMerchantGroupFail(error))
    }
}

// Fetch Merchant Group Admin User
function* fetchMerchantGroupAdminUser({ payload: { options, history } }) {
    try {
        const response = yield call(getMerchantGroupAdminUser, options)
        yield put(getMerchantGroupAdminUserSuccess(response))
    } catch (error) {
        yield put(getMerchantGroupAdminUserFail(error))
    }
}

// Create Merchant Group Admin User
function* onCreateMerchantGroupAdminUser({ payload: { data, options, history } }) {
    try {
        const response = yield call(createMerchantGroupAdminUser, data, options)
        yield put(createMerchantGroupAdminUserSuccess(response))
    } catch (error) {
        yield put(createMerchantGroupAdminUserFail(error))
    }
}

function* merchantGroupSaga() {
    yield takeEvery(GET_MERCHANT_GROUP, fetchMerchantGroup)
    yield takeEvery(ADD_NEW_MERCHANT_GROUP, onAddMerchantGroup)
    yield takeEvery(UPLOAD_BASE64_FILE, uploadBase64FileSaga)
    yield takeEvery(GET_MERCHANT_GROUP_DETAIL, fetchMerchantGroupDetail)
    yield takeEvery(
        GET_MERCHANT_GROUP_COMMUNICATIONS,
        fetchMerchantGroupCommunications
    )
    yield takeEvery(
        MANAGE_MERCHANT_GROUP_COMMUNICATION,
        onManageMerchantGroupCommunication
    )
    yield takeEvery(GET_MERCHANT_GROUP_CONTACTS, fetchMerchantGroupContacts)
    yield takeEvery(MANAGE_MERCHANT_GROUP_CONTACT, onManageMerchantGroupContact)
    yield takeEvery(
        GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS,
        fetchMerchantGroupContactCommunications
    )
    yield takeEvery(
        MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION,
        onManageMerchantGroupContactCommunication
    )
    yield takeEvery(GET_MERCHANT_GROUP_BANKING, fetchMerchantGroupBanking)
    yield takeEvery(GET_MERCHANT_GROUP_BANKING_DETAIL, fetchMerchantGroupBankingDetail)
    yield takeEvery(ADD_NEW_MERCHANT_GROUP_BANKING, onAddNewMerchantGroupBanking)
    yield takeEvery(MANAGE_MERCHANT_GROUP_BANKING, onManageMerchantGroupBanking)
    yield takeEvery(TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT, toggleMerchantGroupBankingDefaultSaga)
    yield takeEvery(CHECK_MERCHANT_GROUP_BANKING_STATUS, checkMerchantGroupBankingStatusSaga)
    yield takeEvery(DELETE_MERCHANT_GROUP, onDeleteMerchantGroup)
    yield takeEvery(GET_MERCHANT_GROUP_ADMIN_USER, fetchMerchantGroupAdminUser)
    yield takeEvery(CREATE_MERCHANT_GROUP_ADMIN_USER, onCreateMerchantGroupAdminUser)
}
export default merchantGroupSaga
